const SportType = {
  SOCCER: 1,
  TENNIS: 2,
  BASKETBALL: 3,
  GOLF: 4,
  VOLLEYBALL: 5,
  BOXING: 6
}
export default SportType
